(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-call-purpose', {
            /*
            parent: 'entity',
            */
            parent: 'dictionary',
            url: '/phone-call-purpose?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallPurpose.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-purpose/phone-call-purposes.html',
                    controller: 'PhoneCallPurposeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'checkOrder,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallPurpose');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('phone-call-purpose-detail', {
            parent: 'phone-call-purpose',
            url: '/phone-call-purpose/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneCallPurpose.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-call-purpose/phone-call-purpose-detail.html',
                    controller: 'PhoneCallPurposeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneCallPurpose');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PhoneCallPurpose', function($stateParams, PhoneCallPurpose) {
                    return PhoneCallPurpose.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-call-purpose',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-call-purpose-detail.edit', {
            parent: 'phone-call-purpose-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-purpose/phone-call-purpose-dialog.html',
                    controller: 'PhoneCallPurposeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallPurpose', function(PhoneCallPurpose) {
                            return PhoneCallPurpose.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-purpose.new', {
            parent: 'phone-call-purpose',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-purpose/phone-call-purpose-dialog.html',
                    controller: 'PhoneCallPurposeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                worth: null,
                                checkOrder: null,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-call-purpose', null, { reload: 'phone-call-purpose' });
                }, function() {
                    $state.go('phone-call-purpose');
                });
            }]
        })
        .state('phone-call-purpose.edit', {
            parent: 'phone-call-purpose',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-purpose/phone-call-purpose-dialog.html',
                    controller: 'PhoneCallPurposeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallPurpose', function(PhoneCallPurpose) {
                            return PhoneCallPurpose.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-purpose', null, { reload: 'phone-call-purpose' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-call-purpose.delete', {
            parent: 'phone-call-purpose',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-purpose/phone-call-purpose-delete-dialog.html',
                    controller: 'PhoneCallPurposeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneCallPurpose', function(PhoneCallPurpose) {
                            return PhoneCallPurpose.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call-purpose', null, { reload: 'phone-call-purpose' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
